/**
 * HerFitHub site content — EASY TO EDIT.
 * Update the strings/images below to change site-wide content. Programs and blog
 * posts live in MongoDB and can be edited from the admin dashboard at /admin.
 */

export const BRAND = {
  name: "HerFitHub",
  tagline: "Women's Strength Coaching",
  coachName: "Maya",
  location: "London",
  email: "mdespotovic@herfithub.com",
  phone: "",
  // Private coaching-client app (Trainerize) — the app account is branded
  // "Strong With Maya" and cannot be renamed. Surfaced as "Client Login" in
  // the navbar so it feels intentional alongside HerFitHub.
  clientAppName: "Strong With Maya",
  clientAppUrl: "https://www.trainerize.com/login.aspx",
  instagram: [
    { handle: "@strongwithmaya", url: "https://instagram.com/strongwithmaya" },
    { handle: "@herfithub.co", url: "https://instagram.com/herfithub.co" },
  ],
};

export const HERO = {
  eyebrow: "Women's Strength Coaching",
  titleLine1: "Strong",
  titleLine2: "starts here.",
  highlightWord: "starts here.",
  body:
    "Women's strength coaching designed to help you feel confident, capable and in control of your body again.",
  image:
    "https://images.unsplash.com/photo-1552848031-326ec03fe2ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHx3b21hbiUyMHN0cmVuZ3RoJTIwdHJhaW5pbmclMjBneW18ZW58MHx8fHwxNzc5MTc5NzQ3fDA&ixlib=rb-4.1.0&q=85",
};

export const HELP_WITH = [
  { title: "Building Strength", icon: "Dumbbell" },
  { title: "Improving Confidence", icon: "Heart" },
  { title: "Weight Training Technique", icon: "Activity" },
  { title: "Rebuilding After Time Away", icon: "Sparkles" },
  { title: "Sustainable Habits", icon: "Leaf" },
  { title: "Online Coaching", icon: "Laptop" },
];

export const VALUE_PROPS = [
  { title: "Personalised Coaching", icon: "UserCheck" },
  { title: "Realistic Training", icon: "Target" },
  { title: "Support & Accountability", icon: "Heart" },
  { title: "Results That Last", icon: "Award" },
];

export const TRUST_BAR = [
  { label: "Women Only Coaching", icon: "Users" },
  { label: "Online Coaching", icon: "Laptop" },
  { label: "London Based", icon: "MapPin" },
  { label: "Supportive Community", icon: "Heart" },
];

export const ABOUT = {
  eyebrow: "About Maya",
  heading: "Hi, I'm Maya",
  paragraphs: [
    "I'm a women's strength coach based in London, helping women rebuild their strength, confidence and trust in their bodies through realistic training that fits around real life.",
    "My coaching is for women who want to feel stronger physically and mentally, whether they're complete beginners, returning after having children, or simply ready to prioritise themselves again.",
    "For me, fitness is about more than aesthetics. It's about discipline, resilience, confidence and becoming the woman you know you're capable of being.",
  ],
  image:
    "https://images.unsplash.com/photo-1590556409324-aa1d726e5c3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxmZW1hbGUlMjBwZXJzb25hbCUyMHRyYWluZXIlMjBzbWlsaW5nfGVufDB8fHx8MTc3OTE3OTc0N3ww&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "online-strength",
    title: "Online Strength Coaching",
    subtitle: "Online coaching for women, anywhere",
    description:
      "Personalised online coaching designed to help women become stronger physically and mentally through realistic and sustainable training that fits around your life.",
    image:
      "https://images.pexels.com/photos/36387535/pexels-photo-36387535.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    forWho: "For women who want women's online strength coaching that adapts to their schedule.",
    cta: "Start Online Coaching",
    icon: "Laptop",
    included: [
      "Personalised training plan",
      "Weekly support & accountability",
      "Exercise & technique guidance",
      "Progress tracking",
      "Beginner friendly",
    ],
  },
  {
    id: "postpartum",
    title: "Postpartum Strength Coaching",
    subtitle: "Rebuild safely, kindly, confidently",
    description:
      "Supportive postpartum strength coaching focused on rebuilding confidence, core strength and overall fitness after having children — at a pace that works for you and your body.",
    image:
      "https://images.pexels.com/photos/3768916/pexels-photo-3768916.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    forWho: "For new and experienced mums wanting strength training after children.",
    cta: "Learn More",
    icon: "Sparkles",
    included: [
      "Core & stability focused training",
      "Beginner friendly progressions",
      "Rebuild strength safely",
      "Coaching around motherhood",
      "Confidence rebuilding",
    ],
  },
  {
    id: "beginner-gym",
    title: "Beginner Gym Coaching For Women",
    subtitle: "Gym confidence, from day one",
    description:
      "Beginner-friendly gym coaching designed to help women feel confident, comfortable and capable in the gym environment — with women-only coaching and structured beginner strength training.",
    image:
      "https://images.unsplash.com/photo-1770026136765-2343c441b9cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHx3b21hbiUyMHN0cmVuZ3RoJTIwdHJhaW5pbmclMjBneW18ZW58MHx8fHwxNzc5MTc5NzQ3fDA&ixlib=rb-4.1.0&q=85",
    forWho: "For women new to the gym who want a structured, supportive entry into strength training.",
    cta: "Start Your Journey",
    icon: "Dumbbell",
    included: [
      "Gym confidence support",
      "Technique guidance",
      "Structured beginner workouts",
      "Women-only coaching",
      "Strength-focused training",
    ],
  },
];

export const COACHING_OPTIONS = [
  "Free Discovery Call",
  "Online Strength Coaching",
  "Postpartum Strength Coaching",
  "Beginner Gym Coaching",
];

export const TESTIMONIALS = [
  {
    quote: "I finally feel confident in the gym again.",
    body:
      "I'd avoided the weights area for years. Maya's coaching gave me a plan, taught me the technique and showed me I belong there. Honestly life-changing.",
    name: "Sarah",
    role: "Online Coaching client",
  },
  {
    quote: "Training feels realistic and sustainable now.",
    body:
      "After kids I thought I'd never get back to feeling like myself. The postpartum programming was kind, structured and worked around school runs and bad sleep nights.",
    name: "Emma",
    role: "Postpartum client, mum of 2",
  },
  {
    quote: "I feel stronger — physically and mentally.",
    body:
      "Maya doesn't shame you, doesn't rush you, and somehow gets you stronger anyway. I leave every session feeling capable, not defeated. That's the magic.",
    name: "Hannah",
    role: "Beginner Gym Coaching client",
  },
];

export const FAQ_ITEMS = [
  {
    q: "Do I need gym experience?",
    a: "Not at all. Most of my clients are complete beginners or returning after time away. The beginner gym coaching for women is specifically designed for women with little or no gym experience — you'll be taught the fundamentals step by step.",
  },
  {
    q: "Is online coaching available?",
    a: "Yes. My online strength coaching for women is available worldwide. You get a personalised training plan, weekly check-ins, technique video reviews and ongoing support — designed around your gym, schedule and goals.",
  },
  {
    q: "Can beginners join?",
    a: "Absolutely. Every program is beginner friendly. Whether you're brand new to lifting, building confidence in the gym, or rebuilding after a long break, you'll start where you are and progress at a pace that works for you.",
  },
  {
    q: "Is postpartum coaching beginner friendly?",
    a: "Yes. Postpartum strength coaching starts with the basics — breath, core, pelvic floor, mobility — and rebuilds loading gradually. It's structured for women rebuilding strength after pregnancy, whether you're 6 weeks or 6 years postpartum.",
  },
  {
    q: "Do you offer women-only coaching?",
    a: "Yes. Every service is women-only by design. The goal is to create a supportive, judgement-free environment where women feel empowered rather than intimidated.",
  },
  {
    q: "How do I get started?",
    a: "Book a free discovery call. We'll talk through your goals, training history and lifestyle, and I'll recommend the right coaching option for you. No pressure, no hard sell — just an honest conversation.",
  },
];

export const PROGRAMS_PERKS = [
  { label: "Instant Access", icon: "Zap" },
  { label: "Train At Your Own Pace", icon: "Clock" },
  { label: "Lifetime Access", icon: "Infinity" },
  { label: "Support & Guidance", icon: "Heart" },
];

export const TRAINING_EXPERIENCE_OPTIONS = [
  "Complete beginner",
  "Some experience (under 1 year)",
  "Intermediate (1–3 years)",
  "Advanced (3+ years)",
];
